import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define a type for the slice state
interface ActionsHistory {
  actions: Action[];
  actionsIndex: number;
  native: boolean;
}

export interface Action {
  type: ActionTypes;
  data: {
    keys: string | string[];
    model?: {
      from: number;
      to: number;
    };
    offset?: {
      axis: "x" | "y" | "z";
      distance: number;
      // from: number;
      // to: number;
    };
    scale?: {
      from: { x: number; y: number; z: number };
      to: { x: number; y: number; z: number };
    };
    rotate?: {
      from: number;
      to: number;
    };
    mirror?: { axis: "x" | "y" | "z" };
    double?: string[]; // Массив ключей, которые были дублированны. В data.keys - ключи, которые появились в результате.
    group?: {
      keys: string[]; // Ключи объектов, которые группируются. В keys - ключ группы,
      name: string;
    };
    texture?: {
      from: string;
      to: string;
    };
  };
}
export enum ActionTypes {
  ADD_MODEL,
  REPLACE_MODEL,
  REMOVE_MODEL,
  SET_OFFSET,
  SET_ROTATION,
  MIRROR,
  DOUBLE,
  SET_SIZE,
  GROUP,
  LOAD_PROJECT,
  SET_TEXTURE,
}

// Define the initial state using that type
const initialState: ActionsHistory = {
  actions: [],
  actionsIndex: -1,
  native: false,
};

export const actionsHistorySlice = createSlice({
  name: "actionsHistory",
  initialState,
  reducers: {
    addAction: (state, action: PayloadAction<Action>) => {
      if (action.payload.data.keys.length === 0) return;
      state.native = true;
      if (state.actions.length > 0)
        state.actions.splice(state.actionsIndex + 1);
      if (state.actions.length >= 20) {
        state.actions = state.actions.slice(1);
        state.actionsIndex -= 1;
      }
      state.actions.push(action.payload);
      state.actionsIndex += 1;
    },
    setNative: (state, action: PayloadAction<boolean>) => {
      state.native = action.payload;
    },
    setActionIndex: (state, action: PayloadAction<number>) => {
      state.actionsIndex = action.payload;
      state.native = false;
    },
    clearActionsHistory: (
      state,
      action: PayloadAction<{ replace?: boolean }>
    ) => {
      state.actions = [];
      state.actionsIndex = -1;
      state.native = false;
      if (!!action.payload.replace) {
        state.actions.push({
          type: ActionTypes.LOAD_PROJECT,
          data: { keys: "" },
        });
        state.actionsIndex += 1;
      }
    },
  },
});

export const { addAction, setActionIndex, setNative, clearActionsHistory } =
  actionsHistorySlice.actions;

export default actionsHistorySlice.reducer;
